<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/credit']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'credit_common_name' | translate"></nz-statistic>
    </a>
</nz-card>